const pinchDetectorComponent = {
  schema: {
    threshold: { type: 'number', default: 0.1 },
  },
  init: function () {
    this.initialDistance = null;
    this.el.sceneEl.addEventListener(
      'touchstart',
      this.onTouchStart.bind(this)
    );
    this.el.sceneEl.addEventListener('touchmove', this.onTouchMove.bind(this));
    this.el.sceneEl.addEventListener('touchend', this.onTouchEnd.bind(this));
  },

  onTouchStart: function (event) {
    if (event.touches.length === 2) {
      this.initialDistance = this.getDistance(
        event.touches[0],
        event.touches[1]
      );
    }
  },

  onTouchMove: function (event) {
    if (event.touches.length === 2 && this.initialDistance !== null) {
      const currentDistance = this.getDistance(
        event.touches[0],
        event.touches[1]
      );
      const spreadChange = currentDistance - this.initialDistance;

      if (Math.abs(spreadChange) > this.data.threshold) {
        const eventDetail = {
          startSpread: this.initialDistance,
          spreadChange: spreadChange,
          currentDistance: currentDistance,
        };

        // Dispatch a custom `twofingermove` event
        this.el.emit('twofingermove', eventDetail);
      }
    }
  },

  onTouchEnd: function () {
    // Reset the initial distance when the pinch ends
    this.initialDistance = null;
  },

  getDistance: function (touch1, touch2) {
    const dx = touch1.clientX - touch2.clientX;
    const dy = touch1.clientY - touch2.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  },
};

export { pinchDetectorComponent };
